import React from 'react';
import {PropTypes} from 'prop-types';
import style from './_SubCategoryMenu.scss';
import {findCategoryInList} from 'base/lib/findCategoryInList';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';

class SubCategoryMenu extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      category: this.props.category,
      parentCategory: null
    };
  }

  componentWillReceiveProps(nextProps) {
    let category = this.state.category;
    if (nextProps.category != this.state.category) {
      category = nextProps.category;
      this.setState({
        category
      });
    }

    if (nextProps.categories && nextProps.categories.length) {

      let parentCategory = findCategoryInList(category.parentId, nextProps.categories);
      this.setState({
        parentCategory: parentCategory || {}
      });
    }

  }

  render() {
    return (
      <section className="list-item-category">
        <h2 className='list-item-title'>{this.state.category.name}</h2>
        {
          this.state.parentCategory && this.state.parentCategory.children && this.state.parentCategory.children.map((item, i) => {
            item.count = 0;
            return (
              <p className='item-category'>
                <Link className='item-link' to={`/list-products/${item.id}`}>{item.name}</Link>
              </p>
            );
          })
        }
      </section>
    );
  }
}

SubCategoryMenu.propTypes = {
  category: PropTypes.object
};

let bindStateToProps = (state) => {
  return {
    categoryHash: state.categoryHash,
    categories: state.categoriesAsTree
  };
};

export default connect(bindStateToProps)(SubCategoryMenu);



// WEBPACK FOOTER //
// ./components/category/SubCategoryMenu.jsx